import { ToastOptions } from '@ionic/core';

export abstract class NgToastService {

    public standardOptions: ToastOptions = {
        animated: true,
        color: 'primary',
        duration: 3000,
        position: 'bottom',
        translucent: false,
        cssClass: 'semi-translucent'
    };

    public standardSuccessToastOptions: ToastOptions = {
        color: 'primary'
    };

    public standardErrorToastOptions: ToastOptions = {
        color: 'danger'
    };

    abstract success(options: ToastOptions): Promise<HTMLIonToastElement>;
    abstract error(options: ToastOptions): Promise<HTMLIonToastElement>;

}
